// extracted by mini-css-extract-plugin
export default {"user_active":"LocationInfo_user_active__Y0+tB","user_not_active":"LocationInfo_user_not_active__MukH1"};